/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as SellRouteRouteImport } from './../routes/sell/route'
import { Route as ManageRouteRouteImport } from './../routes/manage/route'
import { Route as InstitutionsRouteRouteImport } from './../routes/institutions/route'
import { Route as BuyRouteRouteImport } from './../routes/buy/route'
import { Route as TasksIndexRouteImport } from './../routes/tasks/index'
import { Route as SettingsIndexRouteImport } from './../routes/settings/index'
import { Route as SellIndexRouteImport } from './../routes/sell/index'
import { Route as PortfoliosIndexRouteImport } from './../routes/portfolios/index'
import { Route as ManageIndexRouteImport } from './../routes/manage/index'
import { Route as InstitutionsIndexRouteImport } from './../routes/institutions/index'
import { Route as HelpIndexRouteImport } from './../routes/help/index'
import { Route as BuyIndexRouteImport } from './../routes/buy/index'
import { Route as HomeIndexRouteImport } from './../routes/_home/index'
import { Route as SellPoolIdRouteImport } from './../routes/sell/$poolId'
import { Route as ManagePoolIdRouteImport } from './../routes/manage/$poolId'
import { Route as InstitutionsIdRouteImport } from './../routes/institutions/$id'
import { Route as BuyInterestedRouteImport } from './../routes/buy/interested'
import { Route as BuyPoolIdRouteImport } from './../routes/buy/$poolId'

const SellRouteRoute = SellRouteRouteImport.update({
  id: '/sell',
  path: '/sell',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageRouteRoute = ManageRouteRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => rootRouteImport,
} as any)
const InstitutionsRouteRoute = InstitutionsRouteRouteImport.update({
  id: '/institutions',
  path: '/institutions',
  getParentRoute: () => rootRouteImport,
} as any)
const BuyRouteRoute = BuyRouteRouteImport.update({
  id: '/buy',
  path: '/buy',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SellIndexRoute = SellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SellRouteRoute,
} as any)
const PortfoliosIndexRoute = PortfoliosIndexRouteImport.update({
  id: '/portfolios/',
  path: '/portfolios/',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageIndexRoute = ManageIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ManageRouteRoute,
} as any)
const InstitutionsIndexRoute = InstitutionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InstitutionsRouteRoute,
} as any)
const HelpIndexRoute = HelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => rootRouteImport,
} as any)
const BuyIndexRoute = BuyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BuyRouteRoute,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/_home/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SellPoolIdRoute = SellPoolIdRouteImport.update({
  id: '/$poolId',
  path: '/$poolId',
  getParentRoute: () => SellRouteRoute,
} as any)
const ManagePoolIdRoute = ManagePoolIdRouteImport.update({
  id: '/$poolId',
  path: '/$poolId',
  getParentRoute: () => ManageRouteRoute,
} as any)
const InstitutionsIdRoute = InstitutionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => InstitutionsRouteRoute,
} as any)
const BuyInterestedRoute = BuyInterestedRouteImport.update({
  id: '/interested',
  path: '/interested',
  getParentRoute: () => BuyRouteRoute,
} as any)
const BuyPoolIdRoute = BuyPoolIdRouteImport.update({
  id: '/$poolId',
  path: '/$poolId',
  getParentRoute: () => BuyRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/buy': typeof BuyRouteRouteWithChildren
  '/institutions': typeof InstitutionsRouteRouteWithChildren
  '/manage': typeof ManageRouteRouteWithChildren
  '/sell': typeof SellRouteRouteWithChildren
  '/buy/$poolId': typeof BuyPoolIdRoute
  '/buy/interested': typeof BuyInterestedRoute
  '/institutions/$id': typeof InstitutionsIdRoute
  '/manage/$poolId': typeof ManagePoolIdRoute
  '/sell/$poolId': typeof SellPoolIdRoute
  '/': typeof HomeIndexRoute
  '/buy/': typeof BuyIndexRoute
  '/help/': typeof HelpIndexRoute
  '/institutions/': typeof InstitutionsIndexRoute
  '/manage/': typeof ManageIndexRoute
  '/portfolios/': typeof PortfoliosIndexRoute
  '/sell/': typeof SellIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tasks/': typeof TasksIndexRoute
}
export interface FileRoutesByTo {
  '/buy/$poolId': typeof BuyPoolIdRoute
  '/buy/interested': typeof BuyInterestedRoute
  '/institutions/$id': typeof InstitutionsIdRoute
  '/manage/$poolId': typeof ManagePoolIdRoute
  '/sell/$poolId': typeof SellPoolIdRoute
  '/': typeof HomeIndexRoute
  '/buy': typeof BuyIndexRoute
  '/help': typeof HelpIndexRoute
  '/institutions': typeof InstitutionsIndexRoute
  '/manage': typeof ManageIndexRoute
  '/portfolios': typeof PortfoliosIndexRoute
  '/sell': typeof SellIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/tasks': typeof TasksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/buy': typeof BuyRouteRouteWithChildren
  '/institutions': typeof InstitutionsRouteRouteWithChildren
  '/manage': typeof ManageRouteRouteWithChildren
  '/sell': typeof SellRouteRouteWithChildren
  '/buy/$poolId': typeof BuyPoolIdRoute
  '/buy/interested': typeof BuyInterestedRoute
  '/institutions/$id': typeof InstitutionsIdRoute
  '/manage/$poolId': typeof ManagePoolIdRoute
  '/sell/$poolId': typeof SellPoolIdRoute
  '/_home/': typeof HomeIndexRoute
  '/buy/': typeof BuyIndexRoute
  '/help/': typeof HelpIndexRoute
  '/institutions/': typeof InstitutionsIndexRoute
  '/manage/': typeof ManageIndexRoute
  '/portfolios/': typeof PortfoliosIndexRoute
  '/sell/': typeof SellIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tasks/': typeof TasksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/buy'
    | '/institutions'
    | '/manage'
    | '/sell'
    | '/buy/$poolId'
    | '/buy/interested'
    | '/institutions/$id'
    | '/manage/$poolId'
    | '/sell/$poolId'
    | '/'
    | '/buy/'
    | '/help/'
    | '/institutions/'
    | '/manage/'
    | '/portfolios/'
    | '/sell/'
    | '/settings/'
    | '/tasks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/buy/$poolId'
    | '/buy/interested'
    | '/institutions/$id'
    | '/manage/$poolId'
    | '/sell/$poolId'
    | '/'
    | '/buy'
    | '/help'
    | '/institutions'
    | '/manage'
    | '/portfolios'
    | '/sell'
    | '/settings'
    | '/tasks'
  id:
    | '__root__'
    | '/buy'
    | '/institutions'
    | '/manage'
    | '/sell'
    | '/buy/$poolId'
    | '/buy/interested'
    | '/institutions/$id'
    | '/manage/$poolId'
    | '/sell/$poolId'
    | '/_home/'
    | '/buy/'
    | '/help/'
    | '/institutions/'
    | '/manage/'
    | '/portfolios/'
    | '/sell/'
    | '/settings/'
    | '/tasks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  BuyRouteRoute: typeof BuyRouteRouteWithChildren
  InstitutionsRouteRoute: typeof InstitutionsRouteRouteWithChildren
  ManageRouteRoute: typeof ManageRouteRouteWithChildren
  SellRouteRoute: typeof SellRouteRouteWithChildren
  HomeIndexRoute: typeof HomeIndexRoute
  HelpIndexRoute: typeof HelpIndexRoute
  PortfoliosIndexRoute: typeof PortfoliosIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TasksIndexRoute: typeof TasksIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sell': {
      id: '/sell'
      path: '/sell'
      fullPath: '/sell'
      preLoaderRoute: typeof SellRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage': {
      id: '/manage'
      path: '/manage'
      fullPath: '/manage'
      preLoaderRoute: typeof ManageRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/institutions': {
      id: '/institutions'
      path: '/institutions'
      fullPath: '/institutions'
      preLoaderRoute: typeof InstitutionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buy': {
      id: '/buy'
      path: '/buy'
      fullPath: '/buy'
      preLoaderRoute: typeof BuyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sell/': {
      id: '/sell/'
      path: '/'
      fullPath: '/sell/'
      preLoaderRoute: typeof SellIndexRouteImport
      parentRoute: typeof SellRouteRoute
    }
    '/portfolios/': {
      id: '/portfolios/'
      path: '/portfolios'
      fullPath: '/portfolios/'
      preLoaderRoute: typeof PortfoliosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage/': {
      id: '/manage/'
      path: '/'
      fullPath: '/manage/'
      preLoaderRoute: typeof ManageIndexRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/institutions/': {
      id: '/institutions/'
      path: '/'
      fullPath: '/institutions/'
      preLoaderRoute: typeof InstitutionsIndexRouteImport
      parentRoute: typeof InstitutionsRouteRoute
    }
    '/help/': {
      id: '/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof HelpIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buy/': {
      id: '/buy/'
      path: '/'
      fullPath: '/buy/'
      preLoaderRoute: typeof BuyIndexRouteImport
      parentRoute: typeof BuyRouteRoute
    }
    '/_home/': {
      id: '/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sell/$poolId': {
      id: '/sell/$poolId'
      path: '/$poolId'
      fullPath: '/sell/$poolId'
      preLoaderRoute: typeof SellPoolIdRouteImport
      parentRoute: typeof SellRouteRoute
    }
    '/manage/$poolId': {
      id: '/manage/$poolId'
      path: '/$poolId'
      fullPath: '/manage/$poolId'
      preLoaderRoute: typeof ManagePoolIdRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/institutions/$id': {
      id: '/institutions/$id'
      path: '/$id'
      fullPath: '/institutions/$id'
      preLoaderRoute: typeof InstitutionsIdRouteImport
      parentRoute: typeof InstitutionsRouteRoute
    }
    '/buy/interested': {
      id: '/buy/interested'
      path: '/interested'
      fullPath: '/buy/interested'
      preLoaderRoute: typeof BuyInterestedRouteImport
      parentRoute: typeof BuyRouteRoute
    }
    '/buy/$poolId': {
      id: '/buy/$poolId'
      path: '/$poolId'
      fullPath: '/buy/$poolId'
      preLoaderRoute: typeof BuyPoolIdRouteImport
      parentRoute: typeof BuyRouteRoute
    }
  }
}

interface BuyRouteRouteChildren {
  BuyPoolIdRoute: typeof BuyPoolIdRoute
  BuyInterestedRoute: typeof BuyInterestedRoute
  BuyIndexRoute: typeof BuyIndexRoute
}

const BuyRouteRouteChildren: BuyRouteRouteChildren = {
  BuyPoolIdRoute: BuyPoolIdRoute,
  BuyInterestedRoute: BuyInterestedRoute,
  BuyIndexRoute: BuyIndexRoute,
}

const BuyRouteRouteWithChildren = BuyRouteRoute._addFileChildren(
  BuyRouteRouteChildren,
)

interface InstitutionsRouteRouteChildren {
  InstitutionsIdRoute: typeof InstitutionsIdRoute
  InstitutionsIndexRoute: typeof InstitutionsIndexRoute
}

const InstitutionsRouteRouteChildren: InstitutionsRouteRouteChildren = {
  InstitutionsIdRoute: InstitutionsIdRoute,
  InstitutionsIndexRoute: InstitutionsIndexRoute,
}

const InstitutionsRouteRouteWithChildren =
  InstitutionsRouteRoute._addFileChildren(InstitutionsRouteRouteChildren)

interface ManageRouteRouteChildren {
  ManagePoolIdRoute: typeof ManagePoolIdRoute
  ManageIndexRoute: typeof ManageIndexRoute
}

const ManageRouteRouteChildren: ManageRouteRouteChildren = {
  ManagePoolIdRoute: ManagePoolIdRoute,
  ManageIndexRoute: ManageIndexRoute,
}

const ManageRouteRouteWithChildren = ManageRouteRoute._addFileChildren(
  ManageRouteRouteChildren,
)

interface SellRouteRouteChildren {
  SellPoolIdRoute: typeof SellPoolIdRoute
  SellIndexRoute: typeof SellIndexRoute
}

const SellRouteRouteChildren: SellRouteRouteChildren = {
  SellPoolIdRoute: SellPoolIdRoute,
  SellIndexRoute: SellIndexRoute,
}

const SellRouteRouteWithChildren = SellRouteRoute._addFileChildren(
  SellRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  BuyRouteRoute: BuyRouteRouteWithChildren,
  InstitutionsRouteRoute: InstitutionsRouteRouteWithChildren,
  ManageRouteRoute: ManageRouteRouteWithChildren,
  SellRouteRoute: SellRouteRouteWithChildren,
  HomeIndexRoute: HomeIndexRoute,
  HelpIndexRoute: HelpIndexRoute,
  PortfoliosIndexRoute: PortfoliosIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TasksIndexRoute: TasksIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
